export default function NotFound () {
    return (
        <div className="redirect">
            <h1>Error 404</h1>
            <p>That page doesn't exist</p>
            <br />
            <a href="/">Back to home</a>
        </div>
    );
}